import React, { useState } from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { CampaignSelector } from '../components/CampaignSelector';
const fmt = (n: number) => n.toLocaleString('en-US');
export function AdvantageProduct() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = 6500 + Math.max(0, campaignMode - 1) * 500;
  const systemFee = 2500;
  const campaignFee = 1250 * (campaignMode + 1);
  const monthlyTotal = systemFee + campaignFee;
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-469" data-mp="2b9vzqet5xn3">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-470" data-mp="1hr8z2n9kj3gh">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-471" data-mp="1dr6vg8k9vzyk" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-472" data-mp="2xm9u0sj91dcn">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-473" data-mp="3bmucfnl9575m">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-474" data-mp="2iyooyt2td423">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-475" data-mp="2nvf67jqcu5p3">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-476" data-mp="205kq8taqo10m">
        <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="mint" data-id="element-477" data-mp="33h1dlsjitx2h" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-478" data-mp="2yiq2lehhpgio">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-479" data-mp="3c9v8gybgb51g">
            <div className="mb-4" data-id="element-480" data-mp="389l0jg43m4jy">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-481" data-mp="2kixfdt569ifg">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-482" data-mp="2flyn7g52jljw">
                ${fmt(buildFee)}
              </div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-483" data-mp="2thsmr8jycykc">
                {['Company and opportunity profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and candidate application flows', 'Full funnel design, from ad to onboarding', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output', 'Ten Sales School tickets'].map((point, i) => <li key={i} className="flex items-start" data-id="element-484" data-mp="7ebycxngg5kn" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-485" data-mp="v3ebptb23c9c" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-486" data-mp="1004tqm6f8hxe">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-487" data-mp="1e0xq7cga9n35">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-488" data-mp="1dz4kbzdhv6w7" />
            <div className="mb-4" data-id="element-489" data-mp="1itqr1p8msb9y">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-490" data-mp="3qbqtsyvshiqt">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-491" data-mp="3m82kaanlkd2x">
                ${fmt(monthlyTotal)}
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-492" data-mp="3hcnapuwmh3cb">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-493" data-mp="3cd0tladob2y8">
                <div className="flex justify-between text-sm" data-id="element-494" data-mp="dsslbbf07nzd">
                  <span className="text-slate-400" data-id="element-495" data-mp="8ur1updo1mnd">Catalyst ATS</span>
                  <span className="text-white font-medium" data-id="element-496" data-mp="8vixg079jkdn">
                    ${fmt(systemFee)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-497" data-mp="3vatygi7uxmy9">
                  <span className="text-slate-400" data-id="element-498" data-mp="3v87qihh215fi">Campaign Management</span>
                  <span className="text-white font-medium" data-id="element-499" data-mp="wlwgj17ve8w3">
                    ${fmt(campaignFee)}
                  </span>
                </div>
              </div>

              <ul className="mt-5 space-y-2 pt-4 border-t border-slate-800/50" data-id="element-500" data-mp="z5je8pg74zeg">
                {['Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-501" data-mp="1i2udwb5qpuuf" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-502" data-mp="1n2f9cblpbl2e" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-503" data-mp="1rtfbpwdlavca">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-504" data-mp="21se8agl2z0ix">
            <div className="mb-4" data-id="element-505" data-mp="25sx0ibqvy8ln">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-506" data-mp="25tztqqbokn4q">
                Sales School Tickets
              </div>
              <div className="flex items-baseline mb-2" data-id="element-507" data-mp="6m2gl4syyefe">
                <span className="text-3xl font-bold text-white" data-id="element-508" data-mp="1qmz82vr60e8">$150</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-509" data-mp="fh094as7fp67">per ticket</span>
              </div>
              <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-510" data-mp="apryxcj1vzrz">
                Sales School tickets are purchased separately based on the number
                of attendees, up to a $5,000 monthly maximum.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-511" data-mp="yel0boifyztz">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-512" data-mp="ufc50f7r6twb">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-513" data-mp="2m1fkz39t8j39">
        <div className="text-center mb-12" data-id="element-514" data-mp="2m3tgtecbdzbv">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-515" data-mp="2q1zii7yapopx">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-516" data-mp="2cauopmhlzqni">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-517" data-mp="22d6ses4cub38">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-518" data-mp="22fswuivy8ah8">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-519" data-mp="27aggo4g0cgph">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-520" data-mp="1ybcwsy90nx9x">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-521" data-mp="154ns6blnnnka" data-mpi={idx}>
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-522" data-mp="1571n8kgc4zru" />
                  <span className="line-through opacity-70" data-id="element-523" data-mp="106m6rk0rbc5n">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-524" data-mp="rdsbwe8tu46o">
            <p className="text-xl text-white font-medium mb-4" data-id="element-525" data-mp="rbfzeglu8m10">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-526" data-mp="heb9q6ssa8fg">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-527" data-mp="8fzl2abh9kpn">
        <div className="max-w-5xl mx-auto" data-id="element-528" data-mp="26t9axsaonrhl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-529" data-mp="26ry93y0sstt4">
            <div data-id="element-530" data-mp="22tgzn7twn78j">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-531" data-mp="22quxjnps9jxp">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-532" data-mp="3povpajw0q5hx">
                <p data-id="element-533" data-mp="3pnassoq58chf">This is not lead generation.</p>
                <p data-id="element-534" data-mp="3ufvm7p550nkf">This is not outsourced recruiting.</p>
                <p data-id="element-535" data-mp="3uihtros1332n">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-536" data-mp="2efics4rr7ie">
                <p className="text-[#7FE0C3] font-medium" data-id="element-537" data-mp="31tau2mgu87ft">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-538" data-mp="3fsaibt0fukbg">
              <div className="flex items-start" data-id="element-539" data-mp="3fp4usi7gjqhu">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-540" data-mp="q2p09iyv3b49">
                  <Shield className="w-6 h-6 text-[#7FE0C3]" data-id="element-541" data-mp="v339h4c78r3v" />
                </div>
                <div data-id="element-542" data-mp="2iaxs7ll3setx">
                  <h3 className="text-white font-bold mb-2" data-id="element-543" data-mp="2i9mqdrb7xh5g">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-544" data-mp="2n8pmund4uf1t">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-545" data-mp="1zcuzowtcjzrd">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-546" data-mp="1ze63gwmsl7ih">
                  <Target className="w-6 h-6 text-[#7FE0C3]" data-id="element-547" data-mp="29asq9qyoi8n5" />
                </div>
                <div data-id="element-548" data-mp="29d5cwhfdt76j">
                  <h3 className="text-white font-bold mb-2" data-id="element-549" data-mp="2dc4crnm9adr4">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-550" data-mp="2da1hop68xufj">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-551" data-mp="1d6acsw53m6zk">
        <div className="text-center mb-12" data-id="element-552" data-mp="193vuqe997b9c">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-553" data-mp="14bw276vijkms">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-554" data-mp="zdb1l6ccmyxt">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-555" data-mp="ubbyzyofo61x">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-[#7FE0C3]/30 transition-colors group" data-id="element-556" data-mp="2frazkbrmweif" data-mpi={idx}>
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-557" data-mp="2twb6ps30a50g">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-[#7FE0C3] transition-colors" data-id="element-558" data-mp="2yo316dpa8uvv">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-559" data-mp="2psvbn06l4cpv">
        <div className="max-w-6xl mx-auto" data-id="element-560" data-mp="3difyvv9rtw4y">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-561" data-mp="3hmnpjxzshm5t">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-562" data-mp="33lbbjs46vumk">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 relative overflow-hidden" data-id="element-563" data-mp="38k625g8eenh8">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-564" data-mp="1s5mpd2yrezmt" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-565" data-mp="1x7bxa9qoqx6o">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-566" data-mp="1pm03cbzspxka" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-567" data-mp="1kmwv6ioirb83">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-568" data-mp="1fovcvzyx3fxo" data-mpi={idx}>
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-569" data-mp="1ay58oq289j4k" />
                    <span data-id="element-570" data-mp="n8ay6f5ds6nh">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-571" data-mp="i86hao0k99wq">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-572" data-mp="vx9l8g2e8nt9" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-573" data-mp="10u87kcftfqgw">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-574" data-mp="15tkxj61zhdnp" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-575" data-mp="1alw7z2ucohui">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-576" data-mp="1jnc9el36t9ml" data-mpi={idx}>
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-577" data-mp="1oldo6ttkyms9">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-578" data-mp="3qcqsphrmysns" />
                    </div>
                    <span data-id="element-579" data-mp="3vaa8im3zfdhu">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. TIMELINE */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-580" data-mp="27opb11hxhi0f">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-581" data-mp="27n4j7jn00d69">
          Partnership Timeline
        </h2>

        <div className="relative" data-id="element-582" data-mp="1yoixxgq56k1s">
          {/* Horizontal connector line (desktop only) */}
          <div className="hidden md:block absolute top-3 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-[#7FE0C3]/30 to-transparent" data-id="element-583" data-mp="2vetcb27n95o9" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-584" data-mp="2rdpxmj1c1fom">
            {[{
            days: 'Days 1–21',
            title: 'Build & Launch',
            items: ['System architecture build', 'Campaign launch', 'Sales School setup', 'First candidates generated']
          }, {
            days: 'Weeks 4–12',
            title: 'Support & Consulting',
            items: ['Weekly support and consulting', 'Establishing strong baseline KPIs', 'Interviewing 30+ triple screened prospects/mo', 'Hiring 15+ people/mo']
          }, {
            days: 'Month 3+',
            title: 'Optimization',
            items: ['Increase conversion rates', 'Improve retention', 'Maximize ROI', 'Scale successful patterns']
          }].map((phase, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-585" data-mp="jr6o796pxezb" data-mpi={idx}>
                {/* Timeline dot */}
                <div className="hidden md:flex items-center justify-center w-6 h-6 rounded-full bg-[#0A0F1C] border-2 border-[#7FE0C3] z-10 mb-8" data-id="element-586" data-mp="5r5c0xl06l4j">
                  <div className="w-2 h-2 rounded-full bg-[#7FE0C3]" data-id="element-587" data-mp="aq04kr8rvo1u" />
                </div>

                <div className="w-full bg-slate-900/30 border border-slate-800 p-6 rounded-xl text-center md:text-left" data-id="element-588" data-mp="3naw1v42wv7q9">
                  <div className="text-[#7FE0C3] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-589" data-mp="3idduhi4jl0kd">
                    {phase.days}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-590" data-mp="3s8ffc1rsbgh5">
                    {phase.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-591" data-mp="a214wcsq5oni">
                    {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-start justify-center md:justify-start" data-id="element-592" data-mp="54heyfmnznfq" data-mpi={i}>
                        <span className="w-1.5 h-1.5 rounded-full bg-slate-700 mr-2 mt-1.5 flex-shrink-0" data-id="element-593" data-mp="ev2lcp8kxw97" />
                        <span data-id="element-594" data-mp="sulg8gcdrb3k">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-595" data-mp="206j3rk8wsocx">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-596" data-mp="208vqsbtixowu">
          <div data-id="element-597" data-mp="257708lfwpxej">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-598" data-mp="256nhx3mch6zz">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-599" data-mp="29665661n1u5z" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-600" data-mp="1cj1h234i4ggt">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-601" data-mp="1qa666ba8tqcw" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-602" data-mp="tpnsqgvan8a6" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-603" data-mp="q9b5upfg7puc">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-604" data-mp="q91byqra8yjd">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-605" data-mp="l96okx6pur32" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-606" data-mp="h7bkxm1bc1m4">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-607" data-mp="7ap190kq3glo" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-608" data-mp="2iynekmkuapi" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-609" data-mp="3ppr9s2qczwmg">
        <div className="max-w-3xl mx-auto" data-id="element-610" data-mp="3ko21uvyfnz2l">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-611" data-mp="3fp77cwr3sm2n">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-612" data-mp="3ehnkp1gs66c1">
            <div className="flex-1 p-6 border border-[#7FE0C3]/30 rounded-lg bg-slate-800/30" data-id="element-613" data-mp="39ikgtkcje65n">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-614" data-mp="34iy2f7kz2jv9">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-615" data-mp="2zj3d38gui2cb">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-616" data-mp="2vj1ifj9j296j">
                The foundation your recruiting runs on.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-617" data-mp="2qq8fn0xmdax3">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-618" data-mp="2lthw23mlvx6x">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-619" data-mp="2grskmmvh1hib">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-620" data-mp="2bu0unyee05gr">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-621" data-mp="nb6dz14ep9se">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-622" data-mp="rchzaug8z8us">
                Leadership
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-623" data-mp="wcmemh5f5xjf">Leadership</h3>
              <p className="text-slate-400 text-sm" data-id="element-624" data-mp="11afih3j92fgj">
                Add it when finding leadership becomes the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-625" data-mp="8n1uhuxj4u8k">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-626" data-mp="dl3csdn4spiz">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-627" data-mp="ic37dc8s2vib">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-628" data-mp="3lzbyd1r8kg1n" />
        </button>
      </section>
    </div>;
}